<template>
  <form v-show="modal"  class="form">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{$t("contacts.new_contact")}}</h5>
        <!--begin::Close-->
        <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
          <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
          <span class="svg-icon svg-icon-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor" />
              <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor" />
            </svg>
          </span>
          <!--end::Svg Icon-->
        </div>
        <!--end::Close-->
      </div>
      <div class="modal-body">
        <div class="form">
          <div class="row mb-5">
            <div class="col-md-9">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group row">
                    <div class="col-9 col-form-label">
                      <!--begin::Radio-->
                      <div class="form-check form-check-custom form-check-inline mb-2">
                        <!--begin::Input-->
                        <input :id="'society'+id" class="form-check-input me-2 h-20px w-20px form-check-success" v-model="contactCreate.contactType" value="society" required type="radio" />
                        <label class="form-check-label me-5" :for="'society'+id">
                          <div class="text-gray-800"> {{$t("contacts.detail.society")}}</div>
                        </label>
                        <!--end::Input-->

                        <!--begin::Input-->
                        <input :id="'particular'+id" class="form-check-input  me-2 h-20px w-20px form-check-success" v-model="contactCreate.contactType" value="particular" required type="radio" />
                        <label class="form-check-label" :for="'particular'+id">
                          <div class="text-gray-800"> {{$t("contacts.detail.particular")}}</div>
                        </label>
                        <!--end::Input-->

                      </div>

                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="form-group col-md-6">
                      <input type="text" v-model="contactCreate.name" class="form-control form-control-solid" :placeholder="contactNamePlaceholder" required>
                    </div>

                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group row">
                    <div class="col-12 col-form-label">

                      <div class="form-check form-check-custom form-check-inline">
                        <!--begin::Input-->
                        <input :id="'customer'+id" class="form-check-input me-2 h-20px w-20px form-check-success" v-model="contactCreate.customer" value="society"  type="checkbox" />
                        <label class="form-check-label me-5" :for="'customer'+id">
                          <div class="text-gray-800"> {{$t("contacts.customer")}}</div>
                        </label>
                        <!--end::Input-->

                        <!--begin::Input-->
                        <input :id="'supplier'+id" class="form-check-input  me-2 h-20px w-20px form-check-success" v-model="contactCreate.supplier" value="particular"  type="checkbox" />
                        <label class="form-check-label" :for="'supplier'+id">
                          <div class="text-gray-800"> {{ $t('contacts.supplier') }}</div>
                        </label>
                        <!--end::Input-->

                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group row">
                <div class="col-lg-8">
                  <!--begin::Image input-->
                  <div class="image-input image-input-outline" data-kt-image-input="true" :style="{backgroundImage: 'url(' + contactCreate.previewAvatar +')'}">
                    <!--begin::Preview existing avatar-->
                    <div class="image-input-wrapper w-125px h-125px" :style="{backgroundImage: 'url(' + contactCreate.previewAvatar +')'}"></div>
                    <!--end::Preview existing avatar-->
                    <!--begin::Label-->
                    <label class="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow" data-kt-image-input-action="change" data-bs-toggle="tooltip" title="Change avatar">
                      <i class="bi bi-pencil-fill fs-7"></i>
                      <!--begin::Inputs-->
                      <input v-on:change="onFileChange" type="file" name="avatar" accept=".png, .jpg, .jpeg" />
                      <input type="hidden" name="avatar_remove" />
                      <!--end::Inputs-->
                    </label>
                    <!--end::Label-->
                    <!--begin::Cancel-->
                    <span class="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow" data-kt-image-input-action="cancel" data-bs-toggle="tooltip" title="Cancel avatar">
                                  <i class="bi bi-x fs-2"></i>
                                </span>
                    <!--end::Cancel-->
                    <!--begin::Remove-->
                    <span class="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow" data-kt-image-input-action="remove" data-bs-toggle="tooltip" title="Remove avatar">
                                  <i class="bi bi-x fs-2"></i>
                                </span>
                    <!--end::Remove-->
                  </div>
                  <!--end::Image input-->
                  <!--begin::Hint-->
                  <div class="form-text">{{ $t('contacts.type_file') }}</div>
                  <!--end::Hint-->
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-5">
            <div class="col-md-6">
              <div class="row">
                <div class="col-md-4">
                  <p class="font-weight-bold">{{$t("contacts.detail.address")}} </p>
                </div>
                <div class="col-md-8 ml-2">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group mb-2">
                        <input v-model="contactCreate.address.street" :placeholder="$t('contacts.placeholder.street')" type="text" class="form-control form-control-solid">
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group mb-2">
                        <input type="text" v-model="contactCreate.address.street2" :placeholder="$t('contacts.placeholder.street2')" class="form-control form-control-solid">
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group mb-2">
                        <input type="text" v-model="contactCreate.address.city" class="form-control form-control-solid" :placeholder="$t('contacts.placeholder.city')">
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group mb-2">
                        <input type="text" v-model="contactCreate.address.zipcode" class="form-control form-control-solid" :placeholder="$t('contacts.placeholder.zipcode')">
                      </div>
                    </div>
                  </div>
                  <div class="form-group mb-2 row">
                    <select :name="'country'+id" :data-placeholder="$t('auth.country')" class="form-select form-select-solid " data-control="select2" v-model="contactCreate.address.country">
                      <option></option>
                      <option v-for="country in getCountries" :key="country.id" :value="country.id">{{ country.name }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="col-md-12">

                <div v-show="contactCreate.contactType == 'particular'" class="form-group mb-2 row">
                  <label  class="col-3 col-form-label">{{$t("contacts.birthday")}} :</label>
                  <div class="col-9">
                    <input  v-model="contactCreate.birthday" class="form-control form-control-solid" id="kt_hbd"/>
                  </div>
                </div>

                <div class="form-group mb-2 row">
                  <label  class="col-3 col-form-label">{{$t("contacts.detail.phone")}} :</label>
                  <div class="col-9">
                    <input :id="'kt_tagify_telephone_' + id" class="form-control tagify " type="text"/>
                  </div>
                </div>
                <div class="form-group mb-2 row">
                  <label  class="col-3 col-form-label">{{$t("contacts.detail.email")}} :</label>
                  <div class="col-9">
                    <input v-model="contactCreate.email" class="form-control form-control-solid"/>
                  </div>
                </div>
                <div class="form-group mb-2 row">
                  <label  class="col-3 col-form-label">{{$t("contacts.detail.website_link")}} :</label>
                  <div class="col-9">
                    <input v-model="contactCreate.website" class="form-control form-control-solid" :placeholder="$t('contacts.placeholder.website')" type="text"/>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
        <button type="submit" id="kt_submit_create_contact" class="btn btn-sm btn-primary fw-bolder">
          <span class="indicator-label">{{ $t('button.save') }}</span>
          <span class="indicator-progress">{{  $t('loading') }}
                <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
        </button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: "OrderDetails"
}
</script>

<style scoped>

</style>